import { memo, useCallback, useEffect } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Modal, Textarea } from "@mantine/core";
import { NodeKey } from "lexical";
import { useForm } from "react-hook-form";
import { object as yupObject, string as yupString } from "yup";

export type HTMLSubmitForm = {
  html: string;
};

export type HTMLTagsData = {
  insertHTMLTag?: (html: string) => void;
  editHTMLTag?: (html: string, nodeKey: NodeKey) => void;
  html?: string;
  nodeKey?: NodeKey;
};

const HTMLTagSelectModal = ({
  opened,
  onClose,
  data,
}: {
  data: HTMLTagsData;
  opened: boolean;
  onClose: () => void;
}) => {
  const onSubmit = useCallback(
    async (formData: HTMLSubmitForm) => {
      if (data.insertHTMLTag) {
        data.insertHTMLTag(formData.html);
      }

      if (data.editHTMLTag && data.nodeKey) {
        data.editHTMLTag(formData.html, data.nodeKey);
      }
    },
    [data]
  );

  const validationSchema = yupObject({
    html: yupString().required("Please enter HTML."),
  }).required();

  const cleanup = () => {
    resetField("html");
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    setValue,
  } = useForm<HTMLSubmitForm>({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (data.html) {
      setValue("html", data.html);
    }
  }, [data.html]);

  return (
    <Modal
      size="lg"
      title="HTML tag"
      onClose={() => {
        onClose();
        cleanup();
      }}
      opened={opened}
    >
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Textarea
            size="lg"
            mb={16}
            label="HTML to embed"
            placeholder="<div>Your HTML embed here </div>"
            {...register("html")}
            error={errors.html?.message}
          />
          <Button fullWidth size="xl" type="submit">
            Add
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default memo(HTMLTagSelectModal);
